import { useLocalStorage } from '@vueuse/core';

export type FileListView = 'list' | 'thumbnail';

/** The file lists' list / thumbnail choice: remembered in this browser, shared by every list, list by default. */
export function useFileListView() {
    return useLocalStorage<FileListView>('fileListView', 'list');
}
